document.addEventListener('DOMContentLoaded', function() {
    // Get all accordion toggles
    const accordionToggles = document.querySelectorAll('.features-accordion__drawer-header');
  
    accordionToggles.forEach(toggle => {
      if (!toggle.hasAttribute('data-listener-attached')) {
        toggle.addEventListener('click', function() {
          const featureDescriptionWrapper = this.closest('.features-accordion__drawer').querySelector('.features-accordion__feature-description-wrapper');
          
          // Toggle display and maximum height
          if (featureDescriptionWrapper.classList.contains('active')) {
            featureDescriptionWrapper.style.maxHeight = '0';
          } else {
            featureDescriptionWrapper.style.maxHeight = featureDescriptionWrapper.scrollHeight + 'px';
          }
  
          featureDescriptionWrapper.classList.toggle('active');
          
          // Toggle button text and add rotation
          if (!this.classList.contains('rotated')) {
            this.classList.add('rotated');
          } else {
            this.classList.remove('rotated');
          }
        });
  
        // Mark that the element has an event listener
        toggle.setAttribute('data-listener-attached', 'true');
      }
    });
  });
  